<mat-table [dataSource]="dataSource" matSort>

  <ng-container matColumnDef="select">
    <mat-header-cell *matHeaderCellDef>
      <mat-checkbox (change)="$event ? masterToggle() : null"
        [checked]="selection.hasValue() && isAllSelected()"
        [indeterminate]="selection.hasValue() && !isAllSelected()"
        [disabled]="dataSource.filteredData && dataSource.filteredData.length === 0"
        aria-label="Select All">
      </mat-checkbox>
    </mat-header-cell>

    <mat-cell mat-cell
      *matCellDef="let row">
      <mat-checkbox (click)="$event.stopPropagation()"
        [disabled]="!row.canSubmit()"
        (change)="$event ? selectRow(row) : null"
        [checked]="selection.isSelected(row)"
        aria-label="Select Row">
      </mat-checkbox>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="lithocode">
    <mat-header-cell *matHeaderCellDef mat-sort-header> Document ID</mat-header-cell>
    <mat-cell *matCellDef="let element">
      <a [routerLink]="['/biographic', element.lithocode, 'review']">
        {{element.lithocode}}
      </a>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="form">
    <mat-header-cell *matHeaderCellDef mat-sort-header> Form / Level</mat-header-cell>
    <mat-cell *matCellDef="let element">
      {{element.form}}
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="stateStudentId">
    <mat-header-cell *matHeaderCellDef mat-sort-header> Student ID Number</mat-header-cell>
    <mat-cell *matCellDef="let element">
      {{element.stateStudentId}}
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="firstName">
    <mat-header-cell *matHeaderCellDef mat-sort-header> First Name</mat-header-cell>
    <mat-cell *matCellDef="let element">
      {{element.firstName}}
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="lastName">
    <mat-header-cell *matHeaderCellDef mat-sort-header> Last Name</mat-header-cell>
    <mat-cell *matCellDef="let element">
      {{element.lastName}}
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="alerts">
    <mat-header-cell *matHeaderCellDef>Alert Type</mat-header-cell>
    <mat-cell *matCellDef="let element">
      {{element.alerts | alertType}}
    </mat-cell>
  </ng-container>

  @if (userHasDraftVersionAce$ | async) {
    <ng-container matColumnDef="formStatus">
      <mat-header-cell *matHeaderCellDef>Form Status</mat-header-cell>
      <mat-cell *matCellDef="let element">
        {{element.formStatus || 'Published'}}
      </mat-cell>
    </ng-container>
  }

  @if (userHasDraftVersionAce$ | async) {
    <ng-container matColumnDef="formEditVersion">
      <mat-header-cell *matHeaderCellDef>Form Version</mat-header-cell>
      <mat-cell *matCellDef="let element">
        {{element.formEditVersion || 2}}
      </mat-cell>
    </ng-container>
  }

  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

  <mat-row [ngClass]="{'mat-error-row': !row.isValid, 'mat-disabled-row': row.scoringStatus === 'rejected'}"
  *matRowDef="let row; columns: displayedColumns;"></mat-row>

</mat-table>

